export default __webpack_public_path__ + "a2b66a6bc7ba8a41ee8d5f3c79aec3c4.svg";